import {
  FETCH_BRAND_PAGE_DETAILS_BEGIN,
  FETCH_BRAND_PAGE_DETAILS_SUCCESS,
  FETCH_BRAND_PAGE_DETAILS_FAILURE,
  SET_PAGE_TYPE,
  RESET_BRAND_LANDING_DETAILS
} from '../constants/brandLandingActionTypes';

const initialState = {
  tabs: '',
  isLoading: true,
  pageType: 'about',
  error: {}
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_BRAND_PAGE_DETAILS_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: {}
      };
    case FETCH_BRAND_PAGE_DETAILS_SUCCESS:
      return {
        ...state,
        tabs: action.payload,
        isLoading: false,
        error: {}
      };
    case FETCH_BRAND_PAGE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case SET_PAGE_TYPE:
      return {
        ...state,
        pageType: action.payload
      }
    case RESET_BRAND_LANDING_DETAILS:
      return {
        ...state,
        tabs: '',
        isLoading: true,
        pageType: 'about'
      }
    default:
      return state;
  }
}
